export const registerZeroValueLineTracker = (Alpine) => {
    Alpine.data(
        'zeroValueLineTracker',
        (initialPending = 0, initialAccepted = 0) => ({
            pending: Number(initialPending ?? 0),
            accepted: Number(initialAccepted ?? 0),
            async handleAcceptedEvent(event) {
                const detail = event?.detail ?? {};
                if (detail.lineId) {
                    this.$dispatch('zero-line-accepted-local', detail);
                }

                this.pending = Math.max(0, this.pending - 1);
                this.accepted += 1;

                if (this.pending === 0) {
                    await this.refreshPanels();
                }
            },
            async refreshPanels() {
                try {
                    const response = await fetch(window.location.href, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    });

                    if (!response.ok) {
                        return;
                    }

                    const html = await response.text();
                    const parser = new DOMParser();
                    const nextDoc = parser.parseFromString(html, 'text/html');
                    this.replacePanel('#invoice-header-panel', nextDoc);
                    this.replacePanel('#export-readiness-panel', nextDoc);
                } catch (error) {
                    console.warn('Invoice header refresh failed', error);
                }
            },
            replacePanel(selector, nextDoc) {
                const nextPanel = nextDoc.querySelector(selector);
                const currentPanel = document.querySelector(selector);

                if (nextPanel !== null && currentPanel !== null) {
                    currentPanel.replaceChildren(...nextPanel.children);
                }
            },
        }),
    );
};
